<template>
  <div>
    <div class="title">
      <span >实验设备</span>
    </div>
    <!-- <div class="table">
      <div class="item" v-for="(item, index) in deviceList" :key="index" @click="routerTo(`/detail?type=facilities`, item)">
        <div><i class="el-icon-d-arrow-right"></i> {{ item.name }}</div>
        <div> {{ item.createdTime | formatDate("YYYY-MM-DD") }}</div>
      </div>
    </div> -->
    <div class="table">
      <div class="item" v-for="item in deviceList" :key="item.id">
        <el-card :body-style="{ padding: '0px' }">
          <div @click="routerTo(`/detail?type=facilities`, item)">
            <img
            :src="item.image"
            class="image"
          />
          <div class="Stitle" style="padding: 14px">
            <span>{{ item.name }}</span>
            <!-- <div class="bottom clearfix">
              <time class="time">{{ item.createdTime | formatDate("YYYY-MM-DD") }}</time>
              <el-button type="text" class="button">查看详情</el-button>
            </div> -->
          </div>
          </div>
        </el-card>
      </div>
    </div>

  </div>
</template>

<script>
import {getDevicePage} from '@/api/api'

export default {
  data () {
    return {
      type: '',
      total: 0,
      currentPage: 1,
      pageSize: 99999,
      deviceList: []
    }
  },
  created () {
    const type = this.$route.query.type
    this.type = type
    this.getDevicePage()
  },
  methods: {
    // 跳转通用富文本页面
    routerTo (path, row) {
      sessionStorage.detail = JSON.stringify(row)
      this.$router.push({
        path
      })
    },
    // 页码切换时触发
    currentChange (e) {
      console.log(e)
    },
    getDevicePage () {
      let data = {
        pageSize: this.pageSize
      }
      getDevicePage(data).then(res => {
        if (res.code === 200) {
          this.deviceList = res.data.list
          this.total = Number(res.data.totalCount)
        }
      })
    }
  }
}
</script>

<style scoped>
/* .title {
  letter-spacing: 1px;
  font-size: 28px;
  line-height:2em;
  color: #2f4f4f;
  border-bottom: 3px solid #2f4f4f;
  font-weight: bold;
}
.serch {
margin-top: 20px;
} */
</style>
<style scoped>
/* .table{
  margin-top: 20px;
  border: 3px solid #2F4F4F;
  padding: 5px 20px;
  box-sizing: border-box;
}
.item{
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
}
.item+.item{
  border-top: 1px solid #2f4f4f8c;
}
.item:hover{
  cursor: pointer;
  color: #D4AF37;
}
.pagination{
  display: flex;
  justify-content: center;
  margin-top: 20px;
} */
.title {
  letter-spacing: 1px;
  font-size: 28px;
  line-height:2em;
  color: #2f4f4f;
  border-bottom: 3px solid #2f4f4f;
  font-weight: bold;
}
.serch {
  margin-top: 20px;
}
</style>
  <style scoped>
.table {
  /* border: 3px solid #2F4F4F;
    padding: 20px;
    box-sizing: border-box; */
    display: flex;
    flex-wrap: wrap;
}
.item {
  /* height: 40px; */
  margin: 20px;
  width: 330px;
}
.item:hover {
  cursor: pointer;
  color: #d4af37;
}
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.time {
    font-size: 13px;
    color: #999;
  }
  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width:330px;
    height: 219px;
    display: block;
    object-fit:cover;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }
  .clearfix:after {
      clear: both
  }
  .Stitle{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/view/facilities.vue